import { createActions, createReducer } from 'reduxsauce';
import { IRequestConfig } from '../../models/Axios';

export interface EventsBannerType {
  url_banner_dashboard: string;
  url_banner_chat_online: string;
  start_date: string;
  end_date: string;
}

export const { Types, Creators } = createActions({
  setEventsBanner: ['data'],
});

export const EVENT_BANNER_INITIAL_STATE: EventsBannerType = {
  url_banner_dashboard: "",
  url_banner_chat_online: "",
  start_date: "",
  end_date: ""
};

const setEventsBanner = (state = EVENT_BANNER_INITIAL_STATE, action: IRequestConfig<Array<string>>) => (
  action.data
);

export default createReducer(EVENT_BANNER_INITIAL_STATE, {
  [Types.SET_EVENTS_BANNER as any]: setEventsBanner,
});
